import {useReducer} from 'react';
import AddArt19SecretMutation from '@admin/graphql-api/_old_mutations/AddArt19Secret';
import CampaignArt19SecretQuery from '@admin/graphql-api/_old_queries/CampaignArt19SecretQuery';
import {graphql} from '@apollo/client/react/hoc';
import {Redirect} from 'react-router-dom';
import {Element, GREEN} from '@core/style';
import {Card, CardHeader} from '@core/ui/Content';
import {Form, Input, Label} from '@core/ui/Form';
import {Submit} from '@core/ui/FormElements';
import ResponsiveContent from '@core/ui/ResponsiveContent';

const AddArt19Secret = ({campaign, art19Secret, addArt19Secret}) => {
  const [state, setState] = useReducer(
    (state, newState) => {
      return {...state, ...newState};
    },
    {
      errors: [],
      complete: false,
      loading: false,
      changed: null,
      secret: art19Secret || campaign.art19Secret || '',
    }
  );

  const onSecretChange = ({target: {value}}) => {
    setState({secret: value, errors: [], changed: true});
  };

  const onSubmit = () => {
    if (!state.secret || state.secret.indexOf('*') > -1) {
      return;
    }

    setState({errors: [], loading: true});

    addArt19Secret({
      secret: state.secret.trim(),
      contentType: 'campaigns.campaign',
      pk: campaign.id,
    })
      .then(
        ({
          data: {
            addArt19Secret: {art19Secret},
          },
        }) => {
          setState({
            changed: false,
            complete: true,
            loading: false,
            secret: art19Secret,
          });
        }
      )
      .catch((resp) => {
        setState({
          loading: false,
          errors: resp.graphQLErrors,
        });
      });
  };

  if (state.complete) {
    return <Redirect to={`/campaigns/${campaign.id}`} />;
  }

  return (
    <ResponsiveContent containerSize='medium'>
      {state.complete ? (
        <Card
          rules={() => ({background: GREEN, color: '#fff', fontWeight: 500})}>
          Successfully updated the Art19 Encryption Key
        </Card>
      ) : (
        ''
      )}

      <Card style-spaced>
        <CardHeader>Add Art19 Encryption Key to Campaign</CardHeader>
        <Form
          loading={state.loading}
          errors={state.errors}
          onSubmit={onSubmit}
          onClose={() => {
            setState({errors: []});
          }}>
          <Label>Art19 Encryption Key</Label>
          <Input
            type='text'
            name='secret'
            required
            value={state.secret}
            onChange={onSecretChange}
            placeholder="It's a really long string that you get from Art19"
            disabled={state.loading}
          />

          <Element rules={() => ({marginTop: '1.5rem', textAlign: 'right'})}>
            <Submit
              value={`${addArt19Secret ? 'Update' : 'Add'} Encryption Key`}
              color='secondary'
              disabled={state.loading || !state.changed}
            />
          </Element>
        </Form>
      </Card>
    </ResponsiveContent>
  );
};

export default graphql(AddArt19SecretMutation, {
  props: ({ownProps: {campaign}, mutate}) => ({
    addArt19Secret: (input) => {
      return mutate({
        variables: {
          input,
        },
        update: (
          store,
          {
            data: {
              addArt19Secret: {art19Secret},
            },
          }
        ) => {
          // Stuff the new journey into the cache.
          const query = {
            query: CampaignArt19SecretQuery,
            variables: {
              id: campaign.id,
            },
          };

          query.data = store.readQuery(query);
          query.data.me.campaign.art19Secret = art19Secret;
          store.writeQuery(query);
        },
      });
    },
  }),
})(AddArt19Secret);
